import React, { memo } from 'react'
import { styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'

//components
import UserInfo from '../components/UserProfile/UserProfile'

//assets
import logo from '../assets/logo.png'
import Banner from '../assets/banner-1.png'

const App = styled('main')(({ theme }) => ({
  width: '100%',
  height: '100vh',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#424242',
  backgroundColor: '#fff'
}))

const Logo = styled('div')(({ theme }) => ({
  marginTop: '24px',
  maxWidth: '100%'
}))

const Profile = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: '20px',
  top: '20px'
}))

const CardWrapper = styled('div')(({ theme }) => ({
  //height: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'flex-start',
  gap: '32px',
  padding: '16px 0'
}))

const Card = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '300px',
  height: '100px',
  display: 'flex',
  padding: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff',
  color: '#000',
  borderRadius: '8px',
  border: '1px solid #d9d9d9',
  cursor: 'pointer',
  fontWeight: 500,
  fontSize: '20px',
  '&:hover': { backgroundColor: '#fafafa' }
}))

const DPS_MODULES = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    enabled: true
  },
  {
    name: 'Admin',
    path: '/admin',
    enabled: true
  }
]

const EntryLayout = () => {
  const navigate = useNavigate()
  const unitChangeHandler = (item) => {
    if (item.enabled) {
      navigate(item.path)
    } else {
      //notify through
    }
  }

  return (
    <App>
      <Profile>
        <UserInfo />
      </Profile>
      <Logo>
        <img alt="logo" src={logo} style={{ width: '200px' }} />
      </Logo>
      <h1>Welcome to Industry 4.0 solutions</h1>
      <CardWrapper>
        {DPS_MODULES.map((item) => (
          <Card key={item.path} onClick={() => unitChangeHandler(item)}>
            {item.name}
          </Card>
        ))}
      </CardWrapper>
      <h3>
        <span style={{ fontWeight: 'normal' }}> Powered by</span> Digital
        Productivity Solutions
      </h3>
      <Box sx={{ position: 'relative', width: '100%', marginTop: 'auto' }}>
        <h1 style={{ position: 'absolute', top: '16px', right: '16px', color:'#fff' }}>
          Productivity Through Digitalization
        </h1>
        <img alt="banner" src={Banner} style={{ maxWidth: '100%' }} />
      </Box>
    </App>
  )
}

export default memo(EntryLayout)
